import React from 'react';
import { BrainIcon, ZapIcon, ShieldIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="w-full bg-gray-100 py-6" data-id="element-42">
      <div className="container mx-auto px-4" data-id="element-43">
        <div className="flex flex-wrap justify-center gap-6 mb-4" data-id="element-44">
          <div className="flex items-center" data-id="element-45">
            <BrainIcon className="h-5 w-5 mr-2 text-gray-600" data-id="element-46" />
            <span className="text-sm text-gray-600" data-id="element-47">Kognitiv Forskning</span>
          </div>
          <div className="flex items-center" data-id="element-48">
            <ZapIcon className="h-5 w-5 mr-2 text-gray-600" data-id="element-49" />
            <span className="text-sm text-gray-600" data-id="element-50">Mental Aktivering</span>
          </div>
          <div className="flex items-center" data-id="element-51">
            <ShieldIcon className="h-5 w-5 mr-2 text-gray-600" data-id="element-52" />
            <span className="text-sm text-gray-600" data-id="element-53">Testad Kvalitet</span>
          </div>
        </div>
        <div className="text-center text-xs text-gray-500" data-id="element-54">
          <p data-id="element-55">
            © {new Date().getFullYear()} Hjärnkraft. Alla rättigheter
            förbehållna.
          </p>
          <p className="mt-1" data-id="element-56">
            Resultaten kan variera från person till person.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;